export default __webpack_public_path__ + "static/media/pt-session-add.b43effeb.svg";